import { StatusCode, http, isFetchError } from '~~core';

import { DocumentscopyInfoSchema } from '../schemas/documentscopy';

export async function appendDocumentscopyPhoto(requestKey: string, documentscopyKey: string, imageUrl: string, position: string) {
  const bodyData = { photo: { documentSide: position, imageUrl } };

  await http(`/notarial/widget/signatures/${requestKey}/documentscopies/${documentscopyKey}/append_photo`, {
    method: 'post',
    body: bodyData,
  });
}

export async function finishDocumentscopy(requestKey: string, documentscopyKey: string) {
  await http(`/notarial/widget/signatures/${requestKey}/documentscopies/${documentscopyKey}/finish`, {
    method: 'post',
  });
}

export async function createDocumentscopy(requestKey: string, documentType: string) {
  const data = await http(`/notarial/widget/signatures/${requestKey}/documentscopies`, {
    method: 'post',
    body: { documentType },
  });

  return DocumentscopyInfoSchema.parse(data);
}

export async function fetchDocumentscopyInfo(requestKey: string, type: string, documentscopyKey?: string) {
  let data;
  const documentType = type.toLowerCase();

  try {
    data = await http(`/notarial/widget/signatures/${requestKey}/documentscopies/${documentscopyKey}`, {
      method: 'get',
    });
  } catch (err) {
    if (!isFetchError(err)) throw err;
    if (err.status !== StatusCode.NOT_FOUND) throw err;

    data = await createDocumentscopy(requestKey, documentType);
  }

  return DocumentscopyInfoSchema.parse(data);
}
